import { collection, query, where, getDoc, getDocs, setDoc, doc } from "firebase/firestore";
import { db } from '../firebase';

const getDateByTimestamp = (timestamp) => {
  const datetime = new Date(
    timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000,
  );
  const month = datetime.toLocaleString('default', { month: 'short' });
  const day = datetime.toLocaleString('default', { day: 'numeric' });
  const year = datetime.toLocaleString('default', { year: 'numeric' });

  return `${month}. ${day}, ${year}`; // e.g. Jan. 16, 2023
}

export const renderHeaderTop = (article, mode='production') => {
  let dateSize;
  let imageSize;

  switch(article.style) {
    case "standard":
      dateSize = 'lg';
      imageSize = 'sm';
      return (
        <div className="article-header-top">
          <p className="article-type">Game Recap</p>
          {/* <p className="article-type-secondary">{ article.type_secondary }</p> */}
          <p className={ "article-title article-title-" + article.style }>{ article.title }</p>
          <p className={ "article-date article-date-" + dateSize }>{ getDateByTimestamp(article.created_at) }</p>
          {/* <div className={ "article-image article-image-" + imageSize }>
            <img className="article-image-content" src={ article.image_link }/>
            <div className="article-image-metadata">
              <span className="article-image-description">{ article.image_desc }</span>
              <span className="article-image-credit">{ article.image_credit }</span>
            </div>
          </div> */}
        </div>
      );
    case "skinny":
      dateSize = 'lg';
      imageSize = 'sm';
      return (
        <div className="article-header-top">
          <p className="article-type"></p>
          <a className="article-type" href={ "/games/" + article.id }>Back to Box Score</a>
          <p className="article-type-secondary">Game Recap</p>
          <p className={ "article-title article-title-" + article.style }>{ article.title }</p>
          <p className={ "article-date article-date-" + dateSize }>{ getDateByTimestamp(article.created_at) }</p>
        </div>
      );
    case "wide":
      dateSize = 'lg';
      imageSize = 'sm';
      return (
        <div className="article-header-top">
          <p className={ "article-title article-title-" + article.style }>{ article.title }</p>
          <p className={ "article-subtitle-" + article.style }>{ article.subtitle }</p>
          <div className={ "article-image article-image-" + imageSize }>
            <img className="article-image-content" src={ article.image_link }/>
            <div className="article-image-metadata">
              <span className="article-image-description">{ article.image_desc }</span>
              <span className="article-image-credit">{ article.image_credit }</span>
            </div>
          </div>
        </div>
      );
    }
}
